import React, { useState } from "react";
import { useProductsContext, useAuthContext } from "../../contexts";
import { v4 as uuid } from "uuid";
import StateCity from "../../../components/helper/State-City";
import commonObj from '../../../utils/Common';


const AddressForm = ({ setShowAddressForm, editAddress, setEditAddress, userType }) => {
  const { addAddress, setCurrentAddress, updateAddress } = useProductsContext();
  const { userInfo } = useAuthContext();
  const [city, setCity] = useState([]);
  const [newAddress, setNewAddress] = useState(
    editAddress
      ? editAddress
      : {
          userId: userInfo?.id,
          fullName: "",
          mobile: "",
          address1: "",
          address2: "",
          nearBy: "",
          pin: "",
          pCity: "",
          pState: "",
          pCountry: "",
        }
  );
  const submitHandler = (e) => {
    e.preventDefault();

    if (editAddress) {
      updateAddress(editAddress.id, newAddress);
    } else {
      addAddress(newAddress);
      setCurrentAddress(newAddress);
    }
    setShowAddressForm(false);
  };
  return (
    <form
      action=""
      className="flex flex-col"
      onSubmit={submitHandler}
    >
      <div className="grid grid-cols-2 gap-4">
        <label className="flex flex-1 flex-col">
          {commonObj.getLabel('Full_Name')} *
          <input
            required
            type="text"
            className="shadow-sm appearance-none border border-red-500 rounded-md p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white"
            onChange={(e) =>
              setNewAddress({ ...newAddress, fullName: e.target.value })
            }
            value={newAddress.fullName}
          />
        </label>
        <label className="flex flex-1 flex-col">
          {commonObj.getLabel('Mobile_No')} *
          <input
            required
            type="text"
            size="12"
            minlength="8"
            maxlength="10"
            pattern= "[0-9]+"
            title="number only"
            className="shadow-sm appearance-none border border-red-500 rounded-md p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white"
            onChange={(e) =>
              setNewAddress({ ...newAddress, mobile: e.target.value })
            }
            value={newAddress.mobile}
          />
        </label>
      {userType!=5 && ( <>
      <label className="flex flex-col">
        {commonObj.getLabel('Flat_House_no_Building')} *
        <input
          required
          type="text"
          className="shadow-sm appearance-none border border-red-500 rounded-md p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white"
          onChange={(e) =>
            setNewAddress({ ...newAddress, address1: e.target.value })
          }
          value={newAddress.address1}
        />
      </label>
      <label className="flex flex-col">
        {commonObj.getLabel('Area_Colony_Street')} *
        <input
          required
          type="text"
          className="shadow-sm appearance-none border border-red-500 rounded-md p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white"
          onChange={(e) =>
            setNewAddress({ ...newAddress, address2: e.target.value })
          }
          value={newAddress.address2}
        />
      </label>

        <label className="flex flex-1 flex-col">
          {commonObj.getLabel('Near_By')}
          <input
            type="text"
            className="shadow-sm appearance-none border border-red-500 rounded-md p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white"
            onChange={(e) =>
              setNewAddress({ ...newAddress, nearBy: e.target.value })
            }
            value={newAddress.nearBy}
          />
        </label>
        </>)}
      </div>
      <div className="flex gap-2 flex-wrap">
        
        <label className="flex flex-1 flex-col">
          {commonObj.getLabel('Pin_Code')} *
          <input
            required
            type="number"
            className="shadow-sm appearance-none border border-red-500 rounded-md p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white"
            onChange={(e) =>
              setNewAddress({ ...newAddress, pin: e.target.value })
            }
            value={newAddress.pin}
          />
        </label>

         <label className="flex flex-1 flex-col">
           {commonObj.getLabel('State')} *
         {/* <input
            required
            type="text"
            className="border rounded-md p-1.5 shadow-sm"
            onChange={(e) =>
              setNewAddress({ ...newAddress, pCity: e.target.value })
            }
            value={newAddress.city}
          />*/}
          <StateCity key={'2'} type={'state'} setCity={setCity} cval={newAddress.pState} userDetails={newAddress} setUserDetails={setNewAddress} classname={'border rounded-md p-1.5 shadow-sm'} /> 
        </label> 
      </div>

      <div className="flex gap-2 flex-wrap"> 
      <label className="flex flex-1 flex-col">
        {commonObj.getLabel('Town_City')} *      
          <StateCity key={'1'} type={'city'} city={city} cval={newAddress.pCity} userDetails={newAddress} setUserDetails={setNewAddress} classname={'border rounded-md p-1.5 shadow-sm'} /> 
        </label> 
        <label className="flex flex-1 flex-col">
          {commonObj.getLabel('Country')}
        <select 
          placeholder="Country"
          className="border rounded-md p-1.5 shadow-sm"
          value={newAddress.pCountry}
          >
          <option value='Монгол'> Монгол</option>
        </select>
        </label>
      </div>

      <div className="flex gap-3 mt-3 flex-wrap">
        <button
          type="button"
          className="btn-rounded-secondary rounded-full flex items-center gap-2 text-sm"
          onClick={() => {
            setShowAddressForm(false);
            setNewAddress({
              fullName: "",
              mobile: "",
              address1: "",
              address2: "",
              nearBy: "",
              pin: "",
              pCity: "",
              pState: "",
              pCountry: "",
            });
            if (editAddress) {
              setEditAddress(null);
            }
          }}
        >
          {commonObj.getLabel('Cancel')}
        </button>
        <button
          type="submit"
          className="btn-rounded-primary rounded-full flex items-center gap-2 text-sm"
        >
          {commonObj.getLabel('Save')}
        </button>
      </div>
      

     
    </form>
  );
};

export default AddressForm;
